<template>
  <aside
    v-if="windowWidth > 1024"
    class="flex flex-col w-[20rem] shrink-0 gap-6"
  >
    <span class="font-medium text-[1.125rem] leading-[1.6875rem]">
      Shop Containers
    </span>
    <div class="flex flex-col gap-2">
      <div
        v-for="link in links"
        :key="link.title"
        class="flex px-4 items-center justify-between w-full h-[2.75rem]"
      >
        <span class="text-[1rem] leading-[1.5rem]">{{ link.title }}</span>
        <a 
          :href="link.path"
          class="w-[1.5rem] h-[1.5rem] p-1 flex items-center justify-center border border-[#EDE9E3] rounded-full bg-white"
        >
          <svg viewBox="0 0 16 16" fill="currentColor" class="w-full h-full" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M4.33366 3.6665V4.99984H10.0603L3.66699 11.3932L4.60699 12.3332L11.0003 5.93984V11.6665H12.3337V3.6665H4.33366Z"
              fill="currentColor"
            />
          </svg>
        </a>
      </div>
      <div class="bg-[#EDE9E3] p-4 flex flex-col gap-4 rounded-lg">
        <span class="text-[1rem] leading-[1.5rem]">
          Request a quote
        </span>
        <span class="text-[0.875rem] leading-[1.25rem]">
          Quickly tell us your needs and we will be in touch shortly.
        </span>
        <div class="mt-5 flex flex-col gap-2">
          <a
            href="/contact"
            class="bg-white py-[0.625rem] px-[1.25rem] rounded-full flex items-center justify-center hover:bg-[#F5F5F5]"
          >
            Get in Touch
          </a>
          <button
            data-vue-init="lead-flow" 
            data-props='{ "gtag": "get_quote"}'  
            class="bg-[#3565FC] text-white py-[0.625rem] px-[1.25rem] rounded-full flex items-center justify-center"
          >
            Request a Quote
          </button>
        </div>
      </div>
    </div>
  </aside>
</template>
<script>
export default {
  props: {
    containerRentalsPath: {
      type: String,
      default: ''
    },
    containerModificationsPath: {
      type: String,
      default: ''
    },
    portableOfficesPath: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      links: [
        {
          title: 'Container Rentals',
          path: this.containerRentalsPath
        },
        {
          title: 'Container Modifications',
          path: this.containerModificationsPath
        },
        {
          title: 'Portable Offices',
          path: this.portableOfficesPath
        }
      ],
      windowWidth: window.innerWidth
    }
  },
  mounted() {
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize() {
      this.windowWidth = window.innerWidth
    }
  }
}
</script>